import { MatsnetLeaderboardEntry, MatsnetUserRank } from "@mezo/api"
import { createSlice } from "@reduxjs/toolkit"

type MatsnetState = {
  fullLeaderboard: MatsnetLeaderboardEntry[]
  isFullyFetched: boolean
  users: number
  userRank: MatsnetUserRank
}

const initialState: MatsnetState = {
  fullLeaderboard: [],
  isFullyFetched: false,
  users: 0,
  userRank: { rank: null, positionChange: 0 },
}

export const matsnetSlice = createSlice({
  name: "matsnet",
  initialState,
  reducers: {
    setMatsnetLeaderboard: (
      immerState,
      { payload }: { payload: MatsnetLeaderboardEntry[] },
    ) => {
      immerState.fullLeaderboard = payload
    },
    setMatsnetLeaderboardFullyFetched: (
      immerState,
      { payload }: { payload: boolean },
    ) => {
      immerState.isFullyFetched = payload
    },
    setMatsnetUsers: (immerState, { payload }: { payload: number }) => {
      immerState.users = payload
    },
    setMatsnetUserRank: (
      immerState,
      { payload }: { payload: MatsnetUserRank },
    ) => {
      immerState.userRank = payload
    },
  },
})

export const {
  setMatsnetLeaderboard,
  setMatsnetLeaderboardFullyFetched,
  setMatsnetUsers,
  setMatsnetUserRank,
} = matsnetSlice.actions

export default matsnetSlice.reducer
